<router-outlet/>
<app-footer [class]="hideFooterOnDesktop() ? 'desk:hidden' : ''"/>